var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.639,
    height: 10.639,
    viewBox: "0 0 10.639 10.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26122",
    "data-name": "Group 26122",
    transform: "translate(-308.627 -39.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25776",
    "data-name": "Group 25776",
    transform: "translate(313.946 36.429) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    y2: 12.046,
    transform: "translate(6.023 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_221",
    "data-name": "Line 221",
    x2: 12.046,
    transform: "translate(0 6.023)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.91d144b4b90ae3cf0ce04f55ecdde29b.svg";
export { ForwardRef as ReactComponent };